import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/roster.actions'
import _ from 'lodash'
import BigCalendar from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import { Popover, Select, Collapse, Button } from 'antd'
import RosterPreview from '../etimeform/RosterPreview'
import { Dialog } from 'primereact/dialog'
import { DndProvider } from 'react-dnd'
import TimeUtils from '../../utils/TimeUtils'
import Toolbar from './Toolbar'
import ColorCustomization from '../settings/theme/ColorCustomization'
import Filter from './Filter'
import { viewConstants } from '../../_constants/view.constants'
import rosterUtil from './util'

const moment = require('moment')
const localizer = BigCalendar.momentLocalizer(moment)
const DragAndDropCalendar = withDragAndDrop(BigCalendar, DndProvider)

const WHOLE_DAY = 86400000
const NORMALWORKING_ACTION = 99

class WorkViewRoster extends React.PureComponent {
    state = {
        currentMonth: new Date(),
        selectedDate: new Date(),
        showModal: false,
        event: {},
        events: [],
        employees: [],
        displayEmployees: [],
        selectedEmployees: [],
        show: false,
        activeTab: '1',
        selectedBranches: [],
        selectedDepartments: [],
        mounted: false,
        currentDate: new Date(),
        modalActionType: '',
        view: 'week',
        showFilters: false,
        showLegend: false,
        hovered: false,
        components: {},
        content: 'weekly',
    }

    components = {
        toolbar: this.renderToolbar,
    }

    componentDidMount() {
        const { displayWorkEvents, branches, departments } = this.props
        if (displayWorkEvents === undefined || displayWorkEvents.length === 0) {
            const options = { range: viewConstants.WEEK, time: new Date() }
            this.props.actions.fetchUpdateWorkETime(options)
        }

        if (branches.length === 0) { this.props.actions.fetchBranchList() }
        if (departments.length === 0) { this.props.actions.fetchDepartmentList() }

        this.setState({ displayEmployees: this.displayEmployees(), mounted: true })
    }

     toggleFilters = () => {
        this.setState(prevState => ({ showFilters: !prevState.showFilters }))
    }

    hasActiveFilters = () => {
        const { selectedEmployees, selectedBranches, selectedDepartments, hasActiveDateRangeFilter } = this.props
        return !!(selectedEmployees?.length > 0 || selectedBranches?.length > 0 || selectedDepartments?.length > 0 || hasActiveDateRangeFilter)
    }

    displayEmployeeIds = displayEmployees => {
        return displayEmployees.map(emp => emp.EmployeeAutoID)
    }

    handleBranchChange = branch => {
        this.setState({ selectedBranches: branch })
        const dispEmployees = rosterUtil.updateDisplayEmployee(this.props.employeeList, branch, this.props.selectedDepartments)
        this.setState({ displayEmployees: this.displayEmployees(dispEmployees) })

        const options = { range: viewConstants.WEEK, time: this.props.currentWeekDate }
        if (!_.isEmpty(dispEmployees)) {
            const cond = { employees: this.displayEmployeeIds(dispEmployees) }
            this.props.actions.fetchUpdateWorkETime(Object.assign({}, cond, options))
        } else {
            this.props.actions.updateDisplayWeekRoster({ events: [] })
        }
    }

    handleDepartmentChange = department => {
        this.setState({ selectedDepartments: department })
        const dispEmployees = rosterUtil.updateDisplayEmployee(this.props.employeeList, this.props.selectedBranches, department)
        this.setState({ displayEmployees: this.displayEmployees(dispEmployees) })

        const options = { range: viewConstants.WEEK, time: this.props.currentWeekDate }
        if (!_.isEmpty(dispEmployees)) {
            const cond = { employees: this.displayEmployeeIds(dispEmployees) }
            this.props.actions.fetchUpdateWorkETime(Object.assign({}, cond, options))
        } else {
            this.props.actions.updateDisplayWeekRoster({ events: [] })
        }
    }

    handleReset = () => {
        this.props.actions.selectEmployees([])
        this.props.actions.selectBranches([])
        this.props.actions.selectDepartments([])

        const options = { range: viewConstants.WEEK, time: this.props.currentWeekDate || new Date() }
        this.props.actions.fetchUpdateWorkETime(options)
    }

    onFormHide = () => {
        this.setState({ modalActionType: '' })
    }

    moveEvent = ({ event, start, end, isAllDay: droppedOnAllDaySlot }) => {
        let allDay = event.allDay
        if (!event.allDay && droppedOnAllDaySlot) { allDay = true }
        else if (event.allDay && !droppedOnAllDaySlot) { allDay = false }
        
        const updatedEvent = { ...event, start, end, allDay }
        const payload = {
            PayrollEmpRosterAutoID: updatedEvent.id,
            PayrollEmpRosterEmployeeID: updatedEvent.EmployeeID,
            PayrollEmpRosterStartDate: updatedEvent.start,
            PayrollEmpRosterEndDate: updatedEvent.end,
            PayrollEmpRosterActionNotes: updatedEvent.Note || '',
            PayrollEmpRosterBreakMinute: updatedEvent.Break,
            PayrollEmpRosterDispTitle: updatedEvent.Title
        }
        this.props.actions.updateWeekEvent(payload)
    }

    copyEvent = ({ event, start, end }) => {
        this.props.actions.copyInsertWeekEvents({ id: event.id, start, end })
    }

    newEvent = event => {
        const eTimeRequest = {
            id: '', title: '',
            actionType: { label: 'Normal working', value: NORMALWORKING_ACTION },
            allDay: event.slots.length == 1,
            dateFrom: event.start,
            dateTo: event.slots.length > 1 ? event.end : undefined,
            draggable: true, status: 'edit', startTime: '09:00', endTime: '17:30',
            duration: '', break: event.break || '0', note: '', existing: false,
        }
        this.setState({ event: eTimeRequest, modalActionType: 'create' })
    }

    renderEvetDetail = event => {
        const eTimeRequest = {
            id: event.id,
            title: event.Title || event.title,
            actionType: _.find(this.props.actionTypes, { value: event.ActionType }),
            allDay: event.allDay,
            dateFrom: event.start,
            startTime: TimeUtils.extractTime(event.start),
            endTime: TimeUtils.extractTime(event.end),
            duration: event.ActionHours || '',
            break: event.Break || 0,
            Note: event.Note || '',
            existing: true,
            status: event.Status,
            employeeID: event.EmployeeID,
            EmployeeName: event.EmployeeName,
            hours: event.hours || 0,
            source: event.source,
        }
        this.setState({ event: eTimeRequest, modalActionType: 'update' })
    }

    customColorEventPropGetter = event => {
        return { style: { backgroundColor: event.Status ? '#1169aa' : '#5FC462' } }
    }

     displayEmployees = employeeFilter => {
        const empList = employeeFilter ? employeeFilter : this.props.employeeList
        return empList.map(emp => ({ label: emp.EmployeeName, value: emp.key }))
    }

    getMenuItems = () => {
        return [
            {
                label: 'View',
                icon: 'pi pi-fw pi-eye',
                items: [
                    {
                        label: 'Week',
                        command: () => this.handleOnView('week'),
                    },
                    { separator: true },
                    {
                        label: 'Calendar',
                        command: () => this.handleOnView('month'),
                    },
                ],
            },
        ]
    }

    handleOnView = view => {
        if (view === 'week') {
            this.setState({ content: 'weekly', showFilters: this.state.showWeekFilters })
            const options = { range: viewConstants.WEEK, time: new Date() }
            this.props.actions.fetchUserETime(options)
        } else {
            this.props.actions.fetchUserETime()
            this.setState({ content: 'roster' })
        }

        this.props.actions.selectEmployee('')
        this.props.actions.selectEmployees([])
        this.props.actions.selectBranches([])
        this.props.actions.selectDepartments([])
        this.props.actions.selectDateRangeFilter({ startDate: null, endDate: null, hasActive: false })
    }

    handleHoverChange = visible => {
        this.setState({ hovered: visible })
    }

        filterDisplayEvents = () => {
            return _.map(this.props.displayEvents || [], obj => obj)
        }

    renderToolbar = (props) => {
        const localLabel = moment(props.date).format('MMM D') + ' – ' + moment(props.date).add(6, 'days').format('D, YYYY')
        return (
            <Toolbar
                {...props}
                view={this.state.view}
                views={['week', 'month']}
                showFilters={this.state.showFilters}
                onToggleFilters={this.toggleFilters}
                hasActiveFilters={this.hasActiveFilters()}
                menuItems={this.getMenuItems()}
                onView={this.handleOnView}
                label={localLabel}
                localizer={localizer}
            >
                <Filter view="week" horizontal={true} filterEvents={() => {}} resetEvents={() => {}} />
            </Toolbar>
        )
    }

    components = {
        toolbar: this.renderToolbar,
    }

     render() {

        const { content } = this.state
        
                const rosterContent = (
                    <div className="roster-content">
                        <div className="calendar-panel">
                            <div className="panel">
                                <div className="panel-body">
                                    <div className="calendar">
                                        <div className="roster m-2">
                                            <DragAndDropCalendar
                                                popup
                                                selectable
                                                localizer={localizer}
                                                events={this.filterDisplayEvents()}
                                                onEventDrop={this.moveEvent}
                                                resizable
                                                onEventResize={this.copyEvent}
                                                onSelectEvent={this.renderEvetDetail}
                                                onSelectSlot={this.handleSelectSlot}
                                                views={['month']}
                                                defaultView={BigCalendar.Views.MONTH}
                                                defaultDate={this.props.currentDate}
                                                eventPropGetter={this.customColorEventPropGetter}
                                                titleAccessor="Title"
                                                startAccessor="start"
                                                endAccessor="end"
                                                showMultiDayTimes={true}
                                                draggableAccessor="draggable"
                                                culture="en-NZ"
                                                tooltipAccessor="Title"
                                                classNameCustom="rbc-calendar"
                                                components={this.components}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
        
        const weeklyView = (
                     <div className="workview-roster">
                <div className="roster-content">
                    <div className="calendar-panel">
                        <div className="panel">
                            <div className="panel-body">
                                <div className="calendar">
                                    <div className="example">
                                        <DragAndDropCalendar
                                            popup selectable localizer={localizer}
                                            events={_.map(this.props.displayWorkEvents, obj => obj)}
                                            onEventDrop={this.moveEvent} resizable onEventResize={this.copyEvent}
                                            onSelectEvent={this.renderEvetDetail} onSelectSlot={this.newEvent}
                                            views={this.state.view === 'month' ? ['month', 'week'] : ['roster']} defaultView={this.state.view === 'month' ? 'month' : BigCalendar.Views.ROSTER}
                                            defaultDate={this.props.currentWeekDate || new Date()}
                                            eventPropGetter={this.customColorEventPropGetter}
                                            titleAccessor="Title" startAccessor="start" endAccessor="end"
                                            showMultiDayTimes={true} draggableAccessor="draggable" culture="en-NZ"
                                            tooltipAccessor="Title" step={1440} timeslots={1}
                                            classNameCustom="rbc-roster"
                                            employees={this.props.employeeList} showHours={true}
                                            components={this.components}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
             </div>

                {/* Roster Preview Modal - Read-only shift details */}
                {this.state.modalActionType === 'update' && this.state.event && this.state.event.id && (
                    <RosterPreview
                        event={this.state.event}
                        onClose={this.onFormHide}
                        employees={this.props.employeeList}
                    />
                )}
         </div>
                 )
        return (
            <div className="">
                            {content === 'roster' && rosterContent}
                            {content === 'weekly' && weeklyView}
                            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        events: state.roster.events,
        displayEvents: state.roster.displayEvents,
        currentWeekDate: state.roster.currentWeekDate,
        displayWorkEvents: state.roster.displayWorkEvents,
        employeeList: state.roster.employeeList,
        displayEmployees: state.roster.displayEmployees,
        selectedEmployees: state.roster.selectedEmployees,
        selectedBranches: state.roster.selectedBranches,
        selectedDepartments: state.roster.selectedDepartments,
        hasActiveDateRangeFilter: state.roster.hasActiveDateRangeFilter,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        actionTypes: state.ActionTypesReducer.actionTypes,
        colors: state.colors.colors,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkViewRoster)